export default "__VITE_ASSET__B954K3Vp__"